import { render } from "./ApprovementTab.vue?vue&type=template&id=10613053&scoped=true&ts=true"
import script from "./ApprovementTab.ts?vue&type=script&lang=ts"
export * from "./ApprovementTab.ts?vue&type=script&lang=ts"

import "./ApprovementTab.scss?vue&type=style&index=0&id=10613053&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10613053"]])

export default __exports__